import React from 'react'
import SettingsLayout from 'components/Settings/Layout'
import LoggedInScaffolding from 'containers/LoggedInScaffolding'
import withAuthRouter from 'containers/AuthRouter'
import GenericPage from 'containers/GenericIntegration/GenericPage'

export default withAuthRouter(() => {
    return (
        <LoggedInScaffolding pageTitle="Settings">
            <SettingsLayout>
                <GenericPage
                    appLabel={'stripe'}
                />
            </SettingsLayout>
        </LoggedInScaffolding>
    )
})
